const validation = {
  required: "Required",
  error: "Must be a valid name",
  firstName: "Must be 15 characters or less",
  lastName: "Must be 20 characters or less",
  dob: "Minimum age should be 5 years 10 months",
  pob: "Must be 15 characters or less",
  motherTongue: "Must be 15 characters or less",
  phone: {
    invalid: "Must be a valid phone number",
    digits: "Must be 10 digits",
  },
  email: "Must be a valid email address",
  address: "Must be 50 characters or less",
  otp: "Invalid OTP. Please try again.",
  success_otp: "OTP sent successfully",
  fail_otp: "Could not send OTP. Please try again",
  mobile: "Invalid Mobile Number",
  fail: "Something went wrong.",
  refresh: "Please refresh the page and try again.",
};
export default validation;
